import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker   } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
	}
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

	render()

	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		 	 		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m6 l6 pt-10">
                        <h5 class="breadcrumbs-title"><span>Archives</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item active">Archives
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
		 
			<div class="col s12 m12 ex-padd">
            <div class="container ">
			   <div class="col s12 m12 mb-20 mt-10 card-content mh-500 iq-card">
                  <section class="invoice-list-wrapper section food">
					<div class="children mb-20 bb pb-2 0 iq-card2 bg-color-1">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="GRADUATE CHILDREN" classname="as" key="1">
						  <div class="center">
							<p class="grad-p">No Graduates.</p>
						  </div>
						</Panel>
					  </Collapse>
					  
					</div> 
					<div class="children mb-20 bb pb-20 iq-card2 bg-color-6">
                     
					  <Collapse defaultActiveKey={['2']} onChange={callback}>
						<Panel header="ARCHIVES CHILDREN" classname="as" key="2">
						  <div class="center">
							<p class="grad-p">No Archives.</p>
						  </div>
						</Panel>
					  </Collapse>
					</div> 
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
